import React from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { BadgeCheck, MapPin, PlayCircle } from 'lucide-react';
import { formatFa, getGlobeCityLabel } from './constants';
import type { CompanionCity } from './types';

type CompanionsHeroCityCardsProps = {
  activeCity: CompanionCity;
  activeCityId: string;
  cities: CompanionCity[];
  onSelectCity: (cityId: string) => void;
  onOpenVideo: (city: CompanionCity) => void;
};

const CompanionsHeroCityCards: React.FC<CompanionsHeroCityCardsProps> = ({
  activeCity,
  activeCityId,
  cities,
  onSelectCity,
  onOpenVideo,
}) => {
  const others = cities.filter((c) => c.id !== activeCityId);

  return (
    <div className="cp-hero-cards">
      <AnimatePresence mode="wait">
        <motion.article
          key={activeCity.id}
          initial={{ opacity: 0, y: 6 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 4 }}
          transition={{ duration: 0.22 }}
          className="cp-hero-cards__active"
        >
          <span className="cp-hero-cards__accent" style={{ backgroundColor: activeCity.tone }} />
          <div className="cp-hero-cards__active-row">
            <span
              className="cp-hero-cards__avatar"
              style={{ background: `linear-gradient(145deg, ${activeCity.tone}, ${activeCity.tone}aa)` }}
            >
              {activeCity.city.slice(0, 1)}
            </span>
            <div className="min-w-0 flex-1 text-right">
              <p className="cp-hero-cards__label">شهر فعال</p>
              <h3 className="cp-hero-cards__name">
                {activeCity.city}
                <span> · {activeCity.country}</span>
              </h3>
              <p className="cp-hero-cards__story">{activeCity.story}</p>
              <div className="cp-hero-cards__meta">
                <span>
                  <MapPin className="h-3 w-3" />
                  {activeCity.region}
                </span>
                <span>
                  <BadgeCheck className="h-3 w-3" />
                  +{formatFa(activeCity.companions)}
                </span>
              </div>
            </div>
            <button
              type="button"
              onClick={() => onOpenVideo(activeCity)}
              className="cp-hero-cards__video-btn"
              aria-label="ویدیو"
            >
              <PlayCircle className="h-4 w-4" />
            </button>
          </div>
        </motion.article>
      </AnimatePresence>

      {others.length > 0 && (
        <div className="cp-hero-cards__list-wrap">
          <p className="cp-hero-cards__list-title">سایر شهرها</p>
          <ul className="cp-hero-cards__list">
            {others.map((city) => (
              <li key={city.id}>
                <button type="button" onClick={() => onSelectCity(city.id)} className="cp-hero-cards__item">
                  <span className="cp-hero-cards__item-dot" style={{ backgroundColor: city.tone }} />
                  <span className="min-w-0 flex-1 text-right">
                    <span className="cp-hero-cards__item-city">{city.city}</span>
                    <span className="cp-hero-cards__item-sub">
                      {getGlobeCityLabel(city.id)} · +{formatFa(city.companions)}
                    </span>
                  </span>
                </button>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export default CompanionsHeroCityCards;
